import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import FormNumberField from "components/FormNumberField";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
/* eslint-disable react/prop-types */

const countryOptions = [
  { value: "Value 1", label: "Value 1" },
  { value: "Value 2", label: "Value 2" },
];

function Fields038C({ formData }) {
  const { formField038C, values, errors, touched } = formData;
  const { totalTaxTNDN, totalExpense } = formField038C;
  return (
    <Box display="flex" flexDirection="column" gap={1} style={{ marginTop: 20 }}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={totalTaxTNDN.name}
            label={totalTaxTNDN.label}
            value={values.totalTaxTNDN}
            error={errors.totalTaxTNDN && touched.totalTaxTNDN}
            success={values.totalTaxTNDN?.toString().length > 0 && !errors.totalTaxTNDN}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={totalExpense.name}
            label={totalExpense.label}
            value={values.totalExpense}
            error={errors.totalExpense && touched.totalExpense}
            success={values.totalExpense?.toString().length > 0 && !errors.totalExpense}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields038C);
